import { RouteGenerator, HttpClient } from "silver";
import { isMyonApiSuccess, MyonApiResponse } from "shared/Api/MyonApiResponse";

export interface BookReview {
	score: number|null;
	created: number;
	createdLabel: string;
	body: string;
	userId: number;
}

export class BookReviewService {

	private readonly cache: { [ bookId: number ]: Promise<BookReview[]> } = { };

	constructor(
		private router: RouteGenerator,
		private httpClient: HttpClient
	) { }

	public getReviews(bookId: number): Promise<BookReview[]> {
		if (this.cache.hasOwnProperty(bookId)) {
			return this.cache[ bookId ];
		}
		const data = { id: bookId.toString() };
		const url = this.router.generate("api/books", "reviews", data, "json");

		return this.cache[ bookId ] = this.httpClient.get(url).then((response: MyonApiResponse<BookReview[]>) => {
			if (!isMyonApiSuccess(response)) {
				console.error(response);
				throw new Error("Could not load book review");
			}
			return response.result;
		});
	}
}
